module.exports = __webpack_public_path__ + "media/images/top-6-44bf1407101e33b580ccc95dcea3e345.png";